import { combineReducers } from 'redux';

import { createActionCreator, createReducer, RequestActionTypes } from 'helpers/redux/reduxHelpers';
import { AppState } from 'helpers/store/models/AppState';
import { ClearContextEntityType, ClearContextSuccessActionInputs } from 'models/context/ClearContext';
import { OrderInfo } from 'models/context/OrderInfo';
import { AuthActionTypes } from 'saga/auth/ducks';
import { canClearContextEntityCheck, ContextActionTypes } from 'saga/context/ducks';

/* STATE */
export interface ContextOrderState {
  order: OrderInfo | null;
}

/* ACTION TYPES */

export enum ContextOrderActionTypes {
  SetContextOrder = '@@Context/Order/SET_CONTEXT_ORDER',
}

/* ACTIONS */
export const setContextOrderActions = createActionCreator(ContextOrderActionTypes.SetContextOrder);

/* REDUCERS */
const initialState: ContextOrderState = {
  order: null,
};

const CLEAR_CONTEXT_RELATED_ENTITIES = [ClearContextEntityType.CUSTOMER];

const order = createReducer(initialState.order, {
  [ContextActionTypes.ClearContext]: {
    [RequestActionTypes.SUCCESS]: (_state: OrderInfo | null, payload: ClearContextSuccessActionInputs) =>
      canClearContextEntityCheck(payload, ClearContextEntityType.ORDER, CLEAR_CONTEXT_RELATED_ENTITIES) ? null : _state,
    [RequestActionTypes.FAILURE]: (_state: OrderInfo | null) => _state,
  },
  [ContextOrderActionTypes.SetContextOrder]: (_state: OrderInfo | null, payload: OrderInfo) => payload,
  [AuthActionTypes.Logout]: {
    [RequestActionTypes.SUCCESS]: () => null,
  },
});

export default combineReducers<ContextOrderState>({ order });

/* SELECTORS */
const selectContextOrder = (state: AppState) => state.context.order || {};

export const selectContextOrderInfo = (state: AppState): OrderInfo | null => selectContextOrder(state).order;

/* SAGAS */

/* EXPORT */
